import { ToastRegion } from '@repo/design-system-kit/components/toast/provider/toast-region';

export function FlashMessages(): React.ReactElement {
  return (
    <div data-test-flash-message-stack>
      <ToastRegion />
    </div>
  );
}
